import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const ObjectInspector: React.FC = () => {
  return (
    <PageTemplate
      title="Object Inspector"
      description="Inspect and analyze object metadata"
    />
  );
};